export async function deleteForeignBankAccount(foreignBankAccountRepository, bankAccountId) {
  return foreignBankAccountRepository.delete(bankAccountId);
};